import { render, staticRenderFns } from "./HelpdeskTicketThread.vue?vue&type=template&id=0861fdfc&scoped=true"
import script from "./HelpdeskTicketThread.vue?vue&type=script&lang=js"
export * from "./HelpdeskTicketThread.vue?vue&type=script&lang=js"
import style0 from "./HelpdeskTicketThread.vue?vue&type=style&index=0&id=0861fdfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0861fdfc",
  null
  
)

export default component.exports